import type { DownloadLink } from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export const downloadLinksApi = {
  async list(): Promise<DownloadLink[]> {
    const res = await api.api.admin['download-links'].$get()
    return unwrap<DownloadLink[]>(res)
  },

  async create(name: string): Promise<DownloadLink> {
    const res = await api.api.admin['download-links'].$post({ json: { name } })
    return unwrap<DownloadLink>(res)
  },

  async archive(id: string): Promise<void> {
    await unwrap(await api.api.admin['download-links'][':id'].archive.$post({ param: { id } }))
  },
}
